<script>
import TwWysiwyg from '../TwWysiwyg';

export default {
  name: 'ItineraryDayProgramListExpandedRow',
  components: { TwWysiwyg },
  props: {
    title: {
      type: String,
      default: null,
    },
    item: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      scopedTeaserText: null,
      scopedText: null,
    };
  },
  created() {
    if (this.item) {
      this.scopedTeaserText = this.item.teaserText;
      this.scopedText = this.item.text;
    }
  },
};
</script>

<template>
  <v-container class="itinerary-day-program-list-expanded-row">
    <v-form class="itinerary-day-program-list-expanded-row__form">
      <v-card>
        <v-card-title class="itinerary-day-program-list-expanded-row__header">
          {{ title }}
        </v-card-title>
        <v-card-text>
          <div class="itinerary-day-program-list-expanded-row__input-wrapper">
            <v-text-field
              :value="scopedTeaserText"
              :label="$t('itinerary.edit.dayProgram.table.teaserText')"
              hide-details
              class="my-3"
              @input="$emit('input', { model: 'teaserText', value: $event, index })"
            />
          </div>
          <div class="itinerary-day-program-list-expanded-row__text-wrapper">
            <tw-wysiwyg
              :value="scopedText"
              :placeholder="$t('itinerary.edit.dayProgram.table.text')"
              class="my-3"
              @change="$emit('input', { model: 'text', value: $event, index })"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-form>
  </v-container>
</template>

<style lang="scss" scoped>
  .itinerary-day-program-list-expanded-row {
    height: 100%;

    &__header {
      font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryDayProgramListExpandedRow.vue